/** @format */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './style/style.scss';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// import { enableES5 } from 'immer';
import * as serviceWorker from 'src/serviceWorker';
import store from 'src/store';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import LoaderWrapper from 'src/utils/LoaderWrapper';
import { AuthProvider } from 'src/contexts/KeyCloakContext';
import App from 'src/App';
import SplashScreen from './components/SplashScreen';

import { trackDataLayer } from './utils/dataLayer';
window.trackDataLayer = trackDataLayer;
// import i18n from './i18n'
// const Storage = window.localStorage

let lang = Storage.i18nextLng;
// const browserLanguage = navigator.language.split("-")[0];
// i18n.changeLanguage(browserLanguage)
// enableES5();

ReactDOM.render(
  <Suspense fallback={<SplashScreen />}>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </Suspense>,
  document.getElementById('root')
);

serviceWorker.register();
document.getElementsByTagName('html')[0].setAttribute('lang', lang);
